import { useRouter } from 'next/router';

const useRouterQueryId = (queryKey = 'id') => {
  const router = useRouter();

  return String(router.query[queryKey]);
};

export default useRouterQueryId;
